import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Stack, Text, Inline, Flex } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

import { EmptySearchVector } from '@/common/displays/assets/empty-search-vector';

import { messages } from './messages';

const styles = cssMap({
	emptyState: {
		paddingBlock: token('space.400'),
		paddingInline: token('space.300'),
	},
	emptyStateDescription: {
		paddingBlockStart: token('space.200'),
	},
	emptyStateIcon: {
		width: '160px',
		height: '160px',
	},
	loadingState: {
		height: '80vh',
		width: '100%',
	},
});

export const OrganizationsPageEmptyState = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.emptyState} testId="organizations-list-empty">
			<Stack alignInline="center" space="space.150">
				<Flex xcss={styles.emptyStateIcon} alignItems="center" justifyContent="center">
					<EmptySearchVector size="large" />
				</Flex>
				<Stack xcss={styles.emptyStateDescription} alignInline="center" space="space.150">
					<Heading size="medium">{formatMessage(messages.emptyTitle)}</Heading>
					<Text color="color.text.subtle" align="center">
						{formatMessage(messages.emptyDescription)}
					</Text>
				</Stack>
			</Stack>
		</Box>
	);
};

export const OrganizationsPageLoadingState = () => {
	const { formatMessage } = useIntl();

	return (
		<Inline
			alignBlock="center"
			alignInline="center"
			xcss={styles.loadingState}
			testId="organizations-list-loading"
		>
			<Spinner
				testId="spinner"
				interactionName="load"
				label={formatMessage(messages.loadingLabel)}
				size="xlarge"
			/>
		</Inline>
	);
};
